<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-table :task="getList" :entity="entity" :actions="actions" :filter-entity="filterEntity" />
</template>
<script>
	import { NoticePattern, NoticePatternFilter } from '@/modules/notification/data/notice-pattern/list'
	import { NoticePatternService } from '@/modules/notification/services'
	export default {
		computed:
		{
			entity()
			{
				return NoticePattern;
			},
			
			filterEntity()
			{
				return NoticePatternFilter;
			},

			service()
			{
				return new NoticePatternService();
			},

			actions()
			{
				return [
					{
						routeName: 'notification.noticePattern.create',
						resourceKey: 'action.create',
						iconName: 'bi-plus-circle',
						activeMode: 'always',
					},
					{
						routeName: 'notification.noticePattern.createImport',
						resourceKey: 'action.import',
						iconName: 'bi-upload',
						activeMode: 'always',
					},

					{
						routeName: 'notification.noticePattern.update',
						resourceKey: 'action.update',
						iconName: 'bi-pen',
						activeMode: 'single',
						dataTransferMode: 'store',
					},

					{
						routeName: 'notification.noticePattern.delete',
						resourceKey: 'action.delete',
						iconName: 'bi-trash',
						activeMode: 'multiple',
						dataTransferMode: 'store',
					},
					{
						resourceKey: 'action.more',
						iconName: 'bi-arrow-down-short',
						activeMode: 'single',
						children: [{
							routeName: 'notification.noticePattern.detail',
							resourceKey: 'notification.noticePatternDetail',
							iconName: 'bi-list-columns',
							activeMode: 'single',
							dataTransferMode: 'store',
						}]
					},

				]
			}
		},
		methods:
		{
			async getList(payload)
			{
				return await this.service.list(payload);
			}
		}
	}
</script>